import { selectUtilityProgramEnrollmentForUser } from '@/reducers/utilityProgramEnrollments'
import { RootState } from '@/store'
import { ID } from '@/types/model'
import getProgramEnrollmentExpiration from '@/utils/utility-program-helpers/getProgramEnrollmentExpiration'
import { createSelector } from '@reduxjs/toolkit'

const selectUserVehicleIsEnrolledProgramEligible = createSelector(
  [
    (state: RootState) =>
      selectUtilityProgramEnrollmentForUser(state)?.utility_program
        ?.device_eligibility?.eligible_vehicle_ids,
    (state: RootState) => {
      const program =
        selectUtilityProgramEnrollmentForUser(state)?.utility_program
      return {
        timezone: program?.preferred_display_timezone,
        enrollmentEndDate:
          program?.view_config_json?.programCard?.enrollmentEndDate,
        rollingDeadline:
          program?.view_config_json?.programCard?.rollingDeadline ?? false,
      }
    },
    (state: RootState, vehicleId?: ID) => vehicleId,
  ],
  (eligibleVehicleIdsFromEnrollmentProgram, expirationInfo, vehicleId) => {
    if (!vehicleId) {
      return false
    }

    const { isExpired } = getProgramEnrollmentExpiration(
      expirationInfo.timezone,
      expirationInfo.enrollmentEndDate,
      expirationInfo.rollingDeadline,
    )

    if (isExpired) {
      return false
    }

    return [...(eligibleVehicleIdsFromEnrollmentProgram ?? [])].includes(
      vehicleId,
    )
  },
)

export default selectUserVehicleIsEnrolledProgramEligible
